<template>
  <div class="job-info">
    <div class="job-info-line">
      <span v-if="job.hot" class="hot-job-icon custom-font-color"></span>
      <div class="job-title custom-font-color" :title="job.title">{{ job.title }}</div>
      <i v-if="showReferral(job)" class="iconfont iconhongbao1 job-referral-icon"></i>
    </div>
    <div class="job-info-line">
      <div class="job-city">{{ jobCityNames }}</div>
      <div class="job-release-date">{{ job.updated_time }}</div>
    </div>
    <div class="job-info-line">
      <div class="job-salary">{{ job.salary }}</div>
      <div class="job-visibility">{{ jobVisibility }}</div>
      <div class="job-role-type">{{ job.role_type }}</div>
      <div class="job-distance">{{ job.distance | formatDistance }}{{ job.distance && 'km'}}</div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    job: {
      type: Object,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {
    jobCityNames () {
      const job = this.job
      if (job.cities.length > 1) {
        return this.$t('companyJobList.multiLocations')
      } else {
        if (job.city_name) {
          return job.city_name
        } else {
          return job.cities.join(' ')
        }
      }
    },
    jobVisibility () {
      const visibility = this.job.job_visibility
      if (visibility === 'E') {
        return this.$t('companyJobList.externalJob')
      } else if (visibility === 'I') {
        return this.$t('companyJobList.internalJob')
      }
      return ''
    }
  },
  created () {

  },
  methods: {
    showReferral (job) {
      return job.referral_settings && job.referral_settings.to_show_referral
    }
  }
}
</script>

<style lang="scss" scoped>
.job-info {
  padding: 12.75px 15px 12.75px 20px;
  border-bottom: 1px solid #aaa;
  background-color: #fff;
  cursor: pointer;

  &:last-child {
    border-bottom: 0;
  }

  .job-info-line {
    display: flex;
    position: relative;

    & + .job-info-line {
      margin-top: 8px;
    }

    > div {
      flex: 1;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: keep-all;
    }

    .job-title {
      font-size: 17px;
      color: #409EFF;
      overflow: initial;
      text-overflow: initial;
      white-space: initial;
      word-break: initial;
    }

    .hot-job-icon {
      font-family: 'icomoon' !important;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      font-style: normal;
      font-weight: 400;
      font-variant: normal;
      font-size: 18px;
      text-transform: none;
      line-height: 1;
      color: #409EFF;
      position: absolute;
      left: -18px;
      bottom: 2px;

      &::before {
        content: "\e91e";
      }
    }

    .job-city {
      font-size: 14px;
    }

    .job-release-date {
      font-size: 14px;
      text-align: right;
    }

    .job-salary {
      font-size: 12px;
    }

    .job-visibility {
      font-size: 12px;
    }

    .job-role-type {
      font-size: 12px;
    }

    .job-distance {
      font-size: 12px;
      text-align: right;
    }

    .job-referral-icon {
      width: 20px;
      height: 20px;
      line-height: 20px;
      color: #409EFF;
      font-size: 28px;
    }

    .show-referral {
      flex: initial;
      width: 32.7%;
      height: 20px;
      margin: auto 0;
      padding: 0 1%;
      border-width: 1px;
      border-style: solid;
      line-height: 20px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &.show-reward-referral {
        width: 36.7%;
      }

      .balance {
        font-size: 13px;
      }
    }

    .show-custom-referral {
      flex: initial;
      width: 20px;
      height: 20px;
      margin: auto 0;
    }
  }

}
</style>
